import React, {FC, useState} from 'react';
import {IOrganization} from '@verdocs/js-sdk';

const CONTAINER_SIZES = {
  sm: 'w-9 h-9 rounded-lg text-xs',
  md: 'w-12 h-12 rounded-xl text-sm',
};

const orgInitials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase() || '?';

/**
 * Displays an organization's logo, falling back to an initials monogram when no logo is set
 * (or the logo fails to load).
 */
export const OrgAvatar: FC<{org: IOrganization; size?: 'sm' | 'md'}> = ({org, size = 'md'}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const logoUrl = org.thumbnail_url || org.full_logo_url;

  if (logoUrl && !imageFailed) {
    return (
      <div
        className={`${CONTAINER_SIZES[size]} flex flex-shrink-0 items-center justify-center overflow-hidden border border-gray-200 bg-white p-1`}>
        <img src={logoUrl} alt={`${org.name} logo`} className="h-full w-full object-contain" onError={() => setImageFailed(true)} />
      </div>
    );
  }

  return (
    <div
      className={`${CONTAINER_SIZES[size]} flex flex-shrink-0 select-none items-center justify-center bg-indigo-100 font-semibold text-indigo-700`}>
      {orgInitials(org.name)}
    </div>
  );
};
